<div class="flex flex-col bg-white rounded-lg overflow-hidden max-w-2xl w-full">

    <!-- Form View -->
    <ng-container *ngIf="!submissionSuccess">
        <!-- Header -->
        <div class="bg-black px-6 py-4 flex flex-row items-center justify-between">
            <h2 class="text-2xl font-bold font-CellCSans text-primary">Call Me Back</h2>
        </div>

        <!-- Content -->
        <div class="px-6 py-6 font-Poppins">

            <!-- Alert -->
            <fuse-alert class="mb-4" *ngIf="showAlert" [appearance]="'outline'" [showIcon]="false" [type]="alert.type">
                {{alert.message}}
            </fuse-alert>

            <!-- Selected Deal -->
            <div *ngIf="packageInfo" class="mb-6 p-4 bg-gray-100 rounded-lg">
                <p class="font-CellCSans"><b>Deal Selected:</b> {{packageInfo.PackageName}}</p>
                <p class="font-CellCSans"><b>Price:</b> R{{packageInfo.CoreOfferable?.Billing_TotalIncl}}<span class="text-base font-normal">pm</span></p>
                <p class="font-CellCSans"><b>Address:</b> {{userGoogleAddress?.formatted_address}}</p>
            </div>

            <h3 class="pb-4 font-bold text-xl font-CellCSans">Personal Details</h3>

            <form *ngIf="interestForm" [formGroup]="interestForm" #interestNgForm="ngForm" class="flex flex-col">

                <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 font-CellCSans">

                    <!-- Full Name -->
                    <mat-form-field class="w-full">
                        <mat-label>Name</mat-label>
                        <input placeholder="Name" id="name" matInput [formControlName]="'LeadContactName'" maxlength="50">
                        <mat-hint align="end">{{interestForm.get('LeadContactName')?.value?.length || 0}}/50</mat-hint>
                        <mat-error *ngIf="interestForm.get('LeadContactName').hasError('required')">
                            Your name is required
                        </mat-error>
                        <mat-error *ngIf="interestForm.get('LeadContactName').hasError('maxlength')">
                            Name cannot exceed 50 characters
                        </mat-error>
                    </mat-form-field>

                    <!-- Last Name -->
                    <mat-form-field class="w-full">
                        <mat-label>Surname</mat-label>
                        <input placeholder="Surname" id="surname" matInput [formControlName]="'LeadContactSurname'" maxlength="50">
                        <mat-hint align="end">{{interestForm.get('LeadContactSurname')?.value?.length || 0}}/50</mat-hint>
                        <mat-error *ngIf="interestForm.get('LeadContactSurname').hasError('required')">
                            Your surname is required
                        </mat-error>
                        <mat-error *ngIf="interestForm.get('LeadContactSurname').hasError('maxlength')">
                            Surname cannot exceed 50 characters
                        </mat-error>
                    </mat-form-field>

                    <!-- Email field -->
                    <mat-form-field class="w-full">
                        <mat-label>Email address</mat-label>
                        <input placeholder="Email Address" id="email" matInput [formControlName]="'LeadContactEmail'" maxlength="100">
                        <mat-hint align="end">{{interestForm.get('LeadContactEmail')?.value?.length || 0}}/100</mat-hint>
                        <mat-error *ngIf="interestForm.get('LeadContactEmail').hasError('required')">
                            Email address is required
                        </mat-error>
                        <mat-error *ngIf="interestForm.get('LeadContactEmail').hasError('email')">
                            Please enter a valid email address
                        </mat-error>
                        <mat-error *ngIf="interestForm.get('LeadContactEmail').hasError('maxlength')">
                            Email address cannot exceed 100 characters
                        </mat-error>
                    </mat-form-field>

                    <!-- Mobile Number -->
                    <mat-form-field class="w-full">
                        <mat-label>Mobile Number</mat-label>
                        <input placeholder="Mobile Number" id="mobilenumber" matInput [formControlName]="'LeadContactNumber'" maxlength="12">
                        <mat-hint align="end">{{interestForm.get('LeadContactNumber')?.value?.length || 0}}/12</mat-hint>
                        <mat-error *ngIf="interestForm.get('LeadContactNumber').hasError('required')">
                            Your mobile number is required
                        </mat-error>
                        <mat-error *ngIf="interestForm.get('LeadContactNumber').hasError('maxlength')">
                            Mobile number cannot exceed 12 characters
                        </mat-error>
                    </mat-form-field>

                </div>

                <div class="flex flex-row gap-4 pt-6">
                    <button
                        [ngClass]="!interestForm.valid || submitButtonDisabled ? 'disabledBtn' : 'activeBtn'"
                        (click)="Submit()" type="submit" mat-flat-button [disabled]="!interestForm.valid || submitButtonDisabled"
                        class="w-full sm:w-48 px-6 py-2 text-center rounded-full flex items-center justify-center gap-2">
                        <mat-spinner *ngIf="submitButtonDisabled" diameter="20" class="inline-block"></mat-spinner>
                        <span
                            [ngClass]="(!interestForm.valid || submitButtonDisabled) ? 'submit-label' : 'text-black'"
                            class="font-semibold font-CellCSans">
                            {{ submitButtonDisabled ? 'Submitting...' : 'Submit' }}
                        </span>
                    </button>
                    <button
                        (click)="close()"
                        type="button"
                        class="w-full sm:w-48 px-6 py-2 text-center rounded-full whitespace-nowrap text-black
                        outline outline-black outline-2 bg-transparent">
                        <span class="text-black text-base max-sm:text-md font-semibold font-CellCSans">
                            Cancel
                        </span>
                    </button>
                </div>

            </form>

        </div>
    </ng-container>

    <!-- Thank You View -->
    <ng-container *ngIf="submissionSuccess">
        <div class="px-6 py-6 font-Poppins">
            <!-- Header -->
            <h2 class="text-2xl font-bold font-CellCSans text-primary">Thank You.</h2>
            <hr class="border-gray-300 mb-4">

            <!-- Message -->
            <p class="text-gray-700 mb-6">
                Thank you for your interest in Cell C Fibre, your details have been successfully submitted.
                A consultant will contact you shortly from <b>84135</b> to conclude your application.
            </p>

            <!-- Deal Selected -->
            <div *ngIf="packageInfo" class="mb-4 p-4 bg-gray-100 rounded-lg">
                <p class="font-CellCSans"><b>Deal Selected:</b> {{packageInfo.PackageName}}</p>
                <p class="font-CellCSans"><b>Price:</b> R{{packageInfo.CoreOfferable?.Billing_TotalIncl}}<span class="text-base font-normal">pm</span></p>
                <p class="font-CellCSans"><b>Address:</b> {{userGoogleAddress?.formatted_address}}</p>
            </div>

            <!-- Reference Number -->
            <div class="mb-6">
                <p class="font-bold font-CellCSans">Your Reference Number:</p>
                <p class="text-gray-700">{{referenceNumber}}</p>
            </div>

            <!-- Regards -->
            <div class="mb-6 py-4 border-t border-b border-gray-300">
                <p class="text-gray-700">Regards,</p>
                <p class="text-gray-700 mt-2">Cell C Fibre Team</p>
            </div>

            <!-- Close Button -->
            <button
                (click)="closeThankYou()"
                class="bg-primary hover:bg-primary-600 text-white font-semibold font-CellCSans px-8 py-3 rounded-full">
                Close
            </button>
        </div>
    </ng-container>

</div>
